export default class BaseView {
  #parentElement;
  #linkClass;

  constructor(parentSelector, linkClass = null) {
    this.#parentElement = document.querySelector(parentSelector);
    this.#linkClass = linkClass;
  }

  #clear() {
    this.#parentElement.innerHTML = "";
  }

  render(html) {
    this.#clear();
    this.#parentElement.insertAdjacentHTML("afterbegin", html);
  }

  addEventHandler(eventType, handler) {
    this.#parentElement.addEventListener(eventType, handler);
  }

  addHandlerClick(handler) {
    this.addEventHandler("click", (event) => {
      const clickedLink = event.target.closest(`.${this.#linkClass}`);
      if (clickedLink) {
        handler(clickedLink.dataset.id);
      }
    });
  }

  setActiveLink(dataId) {
    const currentActiveLink = document.querySelector(
      `.${this.#linkClass}.active`
    );
    if (currentActiveLink) {
      currentActiveLink.classList.remove("active");
    }

    const newActiveLink = document.querySelector(
      `.${this.#linkClass}[data-id="${dataId}"]`
    );
    if (newActiveLink) {
      newActiveLink.classList.add("active");
    }
  }

  static setBrowserTabTitle(title) {
    document.title = title;
  }
}
